import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { Form } from 'react-bootstrap';

import { errorHelper } from '../../utils/tools';
import { yCodes } from '../../utils/constants/ycodes';
import WasteCodeSelect from '../shared/WasteCodeSelect';

const WasteCodeInput = ({ values, setFieldValue, setFieldTouched, touched, errors }) => {

    const wasteCodes = useSelector(state => state.wasteCodes.data);

    const [isVisible, setIsVisible] = useState(false);

    // Ak je vybraný odpad nebezpečný, zobraz Y kód a predvyplň hodnotu
    useEffect(() => {
        if (values.wasteCodeId && wasteCodes.length > 0) {
            const selectedWaste = wasteCodes.find(waste => waste._id === values.wasteCodeId);
            if (selectedWaste) {
                if (selectedWaste.wasteCategory === "N") {
                    setIsVisible(true);
                    if (selectedWaste.yCode) {
                        setFieldValue("yCode", selectedWaste.yCode);
                    }
                } else {
                    setIsVisible(false);
                    setFieldValue("yCode", "");
                }
            }
        }
    }, [values.wasteCodeId, wasteCodes]);

    const handleSelect = (waste) => {
        if (!waste) {
            setFieldValue("wasteCodeId", "");
            setFieldValue("yCode", "");
            setIsVisible(false);
            return;
        }
        setFieldValue("wasteCodeId", waste._id);
        setFieldValue("yCode", "");
        setIsVisible(waste.wasteCategory === "N");
        // Reset error state when a valid selection is made
        setFieldTouched("wasteCodeId", false, true);
    };

    return (
        <>
            <WasteCodeSelect
                label="Kód odpadu*"
                value={values.wasteCodeId}
                onSelect={handleSelect}
                isInvalid={touched.wasteCodeId && errors.wasteCodeId}
                errorMessage={errorHelper({ touched, errors }, 'wasteCodeId').helperText}
            />

            {/* Y Code */}
            {isVisible && (
                <Form.Group className="mb-3" controlId="formBasicYCode">
                    <Form.Label>Y kód</Form.Label>
                    <Form.Select
                        aria-label="Vyberte Y kód"
                        value={values.yCode}
                        onChange={(e) => setFieldValue("yCode", e.target.value)}
                        isInvalid={touched.yCode && errors.yCode}
                    >
                        <option value="">Vyberte Y kód:</option>
                        {yCodes.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.value} - {option.label}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            )}
        </>
    );
};

export default WasteCodeInput;
